import React from 'react'
import styled from 'styled-components'

const getHalfMaxWidth = (props) =>
  parseInt(props.theme.content.max.width, 10) / 2

const FullWidthOuter = styled.div`
  width: ${(props) => props.theme.content.max.width};
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -${(props) => getHalfMaxWidth(props)}px;
  margin-right: -${(props) => getHalfMaxWidth(props)}px;
`

export default function FullWidthArticleWidget({ children }) {
  return <FullWidthOuter>{children}</FullWidthOuter>
}
